module.exports = __webpack_public_path__ + "media/7.0cb25a54.mp3";